import { Button } from '@avanta/shared/components/ui/Button';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { FileText } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { type BillingInvoice } from '../types';
import { useDownloadInvoicePdf } from './useDownloadInvoicePdf';

interface TableActionsProps {
  invoice: BillingInvoice;
}

export const TableActions = ({ invoice }: TableActionsProps): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.INSURANCE);
  const { downloadPdf, isPending } = useDownloadInvoicePdf(invoice);

  return (
    <Button variant="terciary" size="lg" icon="leading" isLoading={isPending} onClick={downloadPdf}>
      <FileText className="size-4" />
      {t('BillingPage.viewDocument.cta')}
    </Button>
  );
};
